import config from "./config";

export function init(themeRegistry) {
  themeRegistry.register("boost", {config});
}
